<template>
  <h1 class="text-xl">تنظیمات</h1>
  <div class="flex mt-6">
    <VPanel class="flex flex-col w-[350px] gap-y-10 min-h-[20rem]">

      <SettingItem to="/setting/room" title="مدیریت اتاق ها" subtitle="افزودن، ویرایش اتاق ها" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/role" title="مدیریت نقش ها" subtitle="افزودن، ویرایش نقش ها" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/user" title="مدیریت کاربران" subtitle="افزودن، ویرایش کاربران" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/product/service" title="مدیریت خدمات" subtitle="افزودن، ویرایش خدمات" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/product/shop" title="مدیریت فروشگاه" subtitle="افزودن، ویرایش محصول" v-if="user.role.type === 'admin' || user.role.type === 'shop'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/product/restaurant" title="مدیریت رستوران" subtitle="افزودن، ویرایش غذاها" v-if="user.role.type === 'admin' || user.role.type === 'restaurant'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/product/caffe" title="مدیریت کافی شاپ" subtitle="افزودن، ویرایش نوشیدنی ها" v-if="user.role.type === 'admin' || user.role.type === 'caffe'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/slider" title="مدیریت اسلایدر" subtitle="افزودن اسلایدر به صفحه اصلی" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/survey-question" title="مدیریت سوالات نظرسنجی" subtitle="ایجاد و ویرایش سوالات نظرسنجی" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/survey" title="نمایش نظرسنجی" subtitle="نمایش نظرسنجی های انجام شده" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/setting/language" title="مدیریت زبان ها" subtitle="ایجاد و ویرایش زبان های برنامه" v-if="user.role.type === 'admin'">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

      <SettingItem to="/logout" title="خروج" subtitle="خروج از پنل کاربری">
        <HomeIcon class="fill-muted"/>
      </SettingItem>

    </VPanel>

    <router-view class="flex-1 mr-10"></router-view>

  </div>
</template>

<script>
import VPanel from "@/components/VPanel";
import HomeIcon from "@/components/Icons/HomeIcon";
import SettingItem from "@/components/SettingItem";
import {mapState} from "vuex";

export default {
  name: "SettingView",
  components: {SettingItem, HomeIcon, VPanel},
  computed: {
    ...mapState(['user'])
  }
}
</script>

<style scoped>

</style>